import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-grupo-formulario',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit{
  dato: FormGroup;
  tieneid;
  materias_anteriores = [];
  tamano = document.body.clientHeight;
  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder) { }

  ngOnInit() {
    this.dato = this.fb.group({
      id: [''],
      materia_anterior_id: [''],
      materia_anterior: [''],
      categorias_materias_id: [''],
      carreras_planes_id: [''],
      nivel: [''],
      orden: [''],
      clave: [''],
      nombre: [''],
      hd: [''],
      hi: [''],
      creditos: ['']
    });

    this.route.params.subscribe(params => {
      this.tieneid = params['id'];
    });
    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }

  filtrar(materias){
    this.materias_anteriores = [];
    let nivel = this.dato.controls.nivel.value;
    let my_id = this.dato.controls.id.value;
    let carrera_plan = this.dato.controls.carreras_planes_id.value;
    console.log(my_id,carrera_plan,nivel);
    materias.forEach(element => {
      if(carrera_plan==element.carreras_planes_id  && my_id!=element.id && element.nivel<nivel){
        this.materias_anteriores.push(element);
      }
    });

    console.log(this.dato.value);
  }

}
